// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"B_thecomp__y9Ygc"};